<template>
  <div class="form-group">
    <p class="label-field">{{ header }}</p>

    <div v-for="(doc, index) in documents" :key="index" class="card-documents card-list-area">
      <div class="card-list-area__w-70">
        <SelectSingleComponentCheckbox
          v-model="doc.id"
          trackBy="text"
          valueProp="id"
          labelOptions="text"
          :options="options"
          :canClear="false"
          :placeholder="placeholder"
        />
      </div>
      <IconComponent name="delete-not-fill" class="card-delete-icon" @click="deleteItem(index)" />
    </div>

    <div v-if="getDuplicates" class="mb-10">
      <span class="invalid-msg">Пожалуйста, удалите пустые или дублирующиеся элементы</span>
    </div>

    <div class="card-add-btn__container">
      <ButtonComponent
        @click="createItem"
        v-if="hasCreateButton"
        mod="only-blue-text"
        :disabled="getDuplicates"
        :class="{ disabled: getDuplicates }"
      >
        <span :class="['card-add-btn__list']"><span>+</span> Создать </span>
      </ButtonComponent>

      <ButtonComponent
        @click="addItem"
        mod="only-blue-text"
        :disabled="getDuplicates"
        :class="{ disabled: getDuplicates }"
      >
        <span :class="['card-add-btn__list']"><span>+</span> {{ buttonName }}</span>
      </ButtonComponent>
    </div>
  </div>
</template>

<script>
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import SelectSingleComponentCheckbox from '@/common/components/redesigned/SelectRedesigned/SelectSingleComponentCheckbox.vue';
  import IconComponent from '@/common/ui/IconComponent.vue';

  export default {
    name: 'DocumentItem',
    components: { SelectSingleComponentCheckbox, IconComponent, ButtonComponent },
    props: {
      header: {
        type: String,
        default: '',
      },
      documents: {
        type: Array,
        default: () => [],
      },
      options: {
        type: Array,
        default: () => [],
      },
      buttonName: {
        type: String,
        default: 'Добавить',
      },
      placeholder: {
        type: String,
        default: 'Выберите',
      },
      hasCreateButton: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      getDuplicates() {
        const idsDocuments = this.documents.map((i) => i.id);
        const duplicates = idsDocuments.filter((document, index) => {
          return idsDocuments.indexOf(document) !== index;
        });
        return duplicates.length;
      },
    },
    watch: {
      getDuplicates(val) {
        this.$emit('duplicates', val);
      },
    },
    methods: {
      addItem() {
        this.$emit('add');
      },
      createItem() {
        this.$emit('create');
      },
      deleteItem(index) {
        this.$emit('delete', index);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../styles/StepCard.scss';
</style>
